/* eslint-disable @typescript-eslint/no-explicit-any */
import { cn } from "@/lib/utils";
import { textVariants } from "@/src/components/Text/Text";
import { Card } from "@/src/components/shad/card";
import { sellPaymentType } from "../DirectTrade";
import beneF from "@assets/beneficiary.svg";
import walletIm from "@assets/wallet.svg";
import exclam from "@assets/exclamation.svg";
import { Modal } from "@/src/components/Modal/Modal";
import useUrlState from "@/src/hooks/use-url-state";
import AddBeneficiary from "./AddBeneficiary";
import { useAppSelector } from "@/src/app/hooks";
import { Check, ChevronRight, XIcon } from "lucide-react";
// import { removeBeneficiaryPayment } from "@/src/features/tradeSlice";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Input } from "@/src/components/shad/input";
import _ from "lodash";
// import { useNavigate } from "react-router-dom";
import { Button } from "@/src/components/Button/Button";
import AddPayments from "../../PaymentMethods/components/AddPayments";
import { useTranslation } from "react-i18next";
import { TOptions } from "i18next";
// import { removeBeneficiaryPayment } from "@/src/features/tradeSlice";

interface Props {
  paymentMethods: ComponentsPaymentMethod[] | undefined;
  setValue: Dispatch<SetStateAction<sellPaymentType[] | undefined>>;
  selectedPayment: sellPaymentType[] | undefined;
  amount: number;
  setAccAmount: Dispatch<SetStateAction<number>>;
  accAmount: number;
  currency: string;
  refetchComponents: any;
}

const SellPayments = ({
  paymentMethods,
  setValue,
  selectedPayment,
  setAccAmount,
  accAmount,
  amount,
  currency,
  refetchComponents,
}: Props) => {
  const { t } = useTranslation();
  const trans = (key: string, variables?: TOptions) =>
    t(`app.buysell.sellPayments.${key}`, variables);
  //   const dispatch = useAppDispatch();
  const [modal, setModal] = useUrlState("add_payment");
  const [open, setOpen] = useState(false);
  const [payment, setPayment] = useState<Array<string>>([""]);
  const { benficiaryPayment } = useAppSelector((state) => state.trade);

  // const navigate = useNavigate();
  // const dispatch = useAppDispatch();

  // Shaping the payment methods to match endpoint
  const modifiedPayment = paymentMethods?.map((pm) => {
    return {
      service_id: pm?.service__id,
      account_name: pm?.account_name,
      account_number: pm?.account_number,
      id: pm?.id.toString(),
      image: pm?.service__image,
      service_name: pm?.service__name,
      amount: "",
      personal_business: pm?.personal_business,
    };
  });

  const modifiedBeneficiary = benficiaryPayment?.map((ben) => {
    return {
      service_id: Number(ben?.service_id),
      account_name: ben?.fields?.account_name,
      account_number: ben?.fields?.account_number,
      id: ben?.id,
      image: ben?.service_image,
      service_name: ben?.service_name,
      amount: "",
      personal_business: ben?.fields?.personal_business,
    };
  });

  // Concantenate the two modified payments
  const allPayments = !_.isEmpty(modifiedBeneficiary)
    ? modifiedBeneficiary?.concat(modifiedPayment as any)
    : modifiedPayment;

  // Function to handle the change of selecting a payment method
  const togglePayment = (id: string) => {
    if (!payment.includes(id)) {
      const onePayment = {
        ...allPayments?.find((item) => item?.id === id),
        amount: amount,
      };
      if (selectedPayment?.length === 0) {
        setValue([onePayment as any]);
        setPayment((val) => [...val, id]);
      } else {
        setPayment((val) => [...val, id]);
        setValue((prev) => [
          ...(prev as any),
          { ...allPayments?.find((item) => item?.id === id), amount: "" },
        ]);
      }
    } else {
      const filteredPayment = payment.filter((item) => item !== id);
      setValue(selectedPayment?.filter((item) => item?.id !== id));
      setPayment(filteredPayment);
    }
  };

  // Function to handle the amount change of selected payment methods
  const setValueAmount = (id: string, amount: number) => {
    setValue((prevState) => {
      return prevState?.map((obj) =>
        obj.id === id ? { ...obj, amount } : obj
      );
    });
  };

  // Function to remove added beneficiary payment methods
  function removeBeneficiaryPaymentMethod(id: string) {
    // Filter the payment ids
    const newPayment = payment.filter((item) => item !== id);
    setPayment(newPayment);

    // Condition to set the amount to the first payment method when its just a payment method left
    if (selectedPayment?.length === 2) {
      const firstPayment = selectedPayment[0];
      setValue([{ ...firstPayment, amount: amount }]);
    } else {
      const newSelected = selectedPayment?.filter((item) => item?.id !== id);
      setValue(newSelected);

      // dispatch(removeBeneficiaryPayment(id));
    }
  }

  useEffect(
    function addAmounts() {
      const amountarr = selectedPayment?.map((payment) => {
        // const mappedAmounts = payment?.amount
        return {
          amount: payment?.amount,
        };
      });
      const totalAmount = amountarr?.reduce((acc, val) => acc + val.amount, 0);
      setAccAmount(totalAmount as number);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedPayment]
  );

  // Refetch components data when modal is open
  useEffect(() => {
    if (open) {
      refetchComponents();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <>
      <Card className="bg-white p-4 grid gap-3">
        <span className={textVariants()}> {trans("header")}</span>
        <div>
          <span className=" flex items-center rounded-md bg-[#E7EDF7] md:bg-white md:dark:bg-grey-800">
            <span className="text-sm p-1 bg-[#E7EDF7] dark:bg-blue-100 rounded-l-md">
              <img src={exclam} className="h-5 w-5 rounded-full" alt="icon" />
            </span>
            <span className="md:text-sm text-xs bg-[#E7EDF7] dark:bg-blue-100 text-infoblue-500 p-1 flex rounded-r-md">
              {trans("desc")}
            </span>
          </span>
        </div>
        <div className="grid md:grid-cols-2  gap-4 my-5">
          <Card
            onClick={() => setModal("open")}
            className={"p-3 flex items-center gap-2 cursor-pointer"}
          >
            <div className="rounded-full bg-[#809AF7] p-1">
              <img src={walletIm} className="h-5 w-5 rounded-full" alt="icon" />
            </div>
            <div className="grid gap-1">
              <span className={textVariants()}>
                {trans("addNewPayment.label")}
              </span>
              <span className={textVariants({ size: "xs" })}>
                {trans("addNewPayment.desc")}
              </span>
            </div>
          </Card>
          <Card
            onClick={() => setModal("one_time")}
            className={"p-3 flex items-center gap-2 cursor-pointer"}
          >
            <div className="rounded-full bg-[#779D74] p-1">
              <img src={beneF} className="h-5 w-5 rounded-full" alt="icon" />
            </div>
            <div className="grid gap-1">
              <span className={textVariants()}>
                {trans("oneTimeBeneficiary.label")}
              </span>
              <span className={textVariants({ size: "xs" })}>
                {trans("oneTimeBeneficiary.desc")}
              </span>
            </div>
          </Card>
        </div>
        <div>
          <span className={textVariants()}>
            {trans("savedPaymentMethods.header")}
          </span>
          <Card
            onClick={() => setOpen(true)}
            className={cn(
              "flex justify-between items-center p-2 cursor-pointer"
            )}
          >
            <div className="p-2 flex items-center gap-2 cursor-pointer">
              <div className="grid gap-1">
                <span className={textVariants({ font: "semibold" })}>
                  {trans("savedPaymentMethods.card.title")}
                </span>
                {/* <span className={textVariants({ size: "xs" })}>
                  {selectedPayment?.length} selected
                </span> */}
              </div>
            </div>

            <ChevronRight className="h-6 w-6 dark:text-white" />
          </Card>
          {selectedPayment && selectedPayment?.length > 1 && (
            <div className="md:mt-5 mt-3">
              <span className={cn(textVariants({ font: "semibold" }))}>
                {trans("savedPaymentMethods.remaining")} {currency.slice(0, 3)}{" "}
                {accAmount > 0
                  ? Number(amount - accAmount).toFixed(2)
                  : amount.toFixed(2)}
              </span>
            </div>
          )}
          <div
            className={cn(
              "gap-3 mt-4",
              selectedPayment?.length === 2
                ? "flex items-center justify-between md:flex-row flex-col "
                : "grid md:grid-cols-2 lg:grid-cols-3"
            )}
          >
            {selectedPayment?.map((item) => (
              <div className="grid flex-1 w-full">
                <Card
                  key={item?.id}
                  className={cn("flex justify-between r px-2")}
                >
                  <div className="p-2 flex items-center gap-2 cursor-pointer">
                    <div>
                      <img
                        src={item?.image}
                        className="h-6 w-6 rounded-full"
                        alt={item?.service_name}
                      />
                    </div>
                    <div className="grid gap-1">
                      <span className={textVariants({ font: "semibold" })}>
                        {item?.service_name}
                      </span>
                      <span className={textVariants({ size: "xs" })}>
                        {item?.account_number}
                      </span>
                    </div>
                  </div>
                  <div
                    onClick={() =>
                      removeBeneficiaryPaymentMethod(item?.id as string)
                    }
                    className="h-5 w-5 rounded-full bg-gray-50 dark:bg-grey-500 flex items-center justify-center my-2 cursor-pointer"
                  >
                    <XIcon className="h-4 w-4 text-gray-500" />
                  </div>
                </Card>
                {payment.includes(item.id as string) &&
                  selectedPayment.length > 1 && (
                    <Input
                      onChange={(e) => {
                        // const selectedAmount = selectedPayment?.find(
                        //   (item) => item?.id === item?.id
                        // )?.amount;
                        setValueAmount(
                          item.id as string,
                          Number(amount) -
                            (Number(accAmount) -
                              Number(item?.amount) +
                              Number(e.target.value)) <
                            0
                            ? Number(e.target.value.slice(0, -1))
                            : Number(e.target.value)
                        );
                      }}
                      type="number"
                      min={1}
                      value={
                        item?.amount > 0 ? item?.amount : undefined
                        // selectedPayment?.find((item) => item?.id === item?.id)
                        //   ?.amount ?? undefined
                      }
                      className="bg-gray-100 border-0 focus:outline-none mt-2 dark:text-white dark:bg-grey-600 h-12"
                      placeholder={`Amount (${currency.slice(0, 3)})`}
                    />
                  )}
              </div>
            ))}
          </div>
          {accAmount - amount !== 0 &&
            selectedPayment &&
            selectedPayment.length >= 2 && (
              <div className="mt-4">
                <span className="text-xs text-red-500">
                  {trans("savedPaymentMethods.excessText", {
                    amount:
                      accAmount > 0
                        ? Number(amount - accAmount).toFixed(2)
                        : amount.toFixed(2),
                  })}
                </span>
              </div>
            )}
        </div>
      </Card>
      <Modal
        open={modal === "one_time"}
        setOpen={(val) => setModal(val ? undefined : "one_time")}
        title={t("app.components.modalTitles.addPaymentMethod")}
      >
        <AddBeneficiary country_id={Number(currency.slice(3, 6))} />
      </Modal>
      <Modal
        open={open}
        setOpen={setOpen}
        title={trans("selectPaymentMethod.title")}
        description={trans("selectPaymentMethod.desc")}
        setter="state"
        size="lg"
        footer={
          <Button
            onClick={() => setOpen(false)}
            // disabled={accAmount !== amount}
            className="w-full"
          >
            {trans("selectPaymentMethod.continueButton")}
          </Button>
        }
      >
        <div>
          {((paymentMethods && paymentMethods?.length >= 1) ||
            !_.isEmpty(benficiaryPayment)) && (
            <div className="pb-5">
              <div className="mt-3 grid md:grid-cols-2 gap-4">
                {paymentMethods
                  ?.filter(
                    (item) =>
                      item?.payment_type === "credit" ||
                      item?.payment_type === "both"
                  )
                  ?.map((method) => (
                    <div key={method?.id}>
                      <Card
                        onClick={() => togglePayment(method?.id.toString())}
                        className={cn(
                          "p-2 flex items-center justify-between cursor-pointer",
                          payment.includes(method?.id.toString()) &&
                            "border border-blue-500 dark:border-blue-200"
                        )}
                      >
                        <div className="flex gap-2">
                          <div>
                            <img
                              src={method?.service__image}
                              className="h-6 w-6 rounded-full"
                              alt={method?.service__name}
                            />
                          </div>
                          <div className="grid gap-1">
                            <span className={textVariants()}>
                              {method?.service__name}
                            </span>
                            <span
                              className={textVariants({
                                size: "xs",
                                variant: "desc",
                              })}
                            >
                              {method?.account_number}
                            </span>
                          </div>
                        </div>
                        <div className="h-5 w-5 rounded-full bg-gray-100 dark:bg-grey-500 flex items-center justify-center">
                          {payment.includes(method?.id.toString()) && (
                            <Check className="h-4 w-4 text-blue-500 dark:text-blue-200" />
                          )}
                        </div>
                      </Card>
                    </div>
                  ))}
                {benficiaryPayment?.map((method) => (
                  <div key={method?.id}>
                    <Card
                      onClick={() => togglePayment(method?.id as string)}
                      className={cn(
                        "p-2 flex items-center justify-between cursor-pointer",
                        payment.includes(method?.id as string) &&
                          "border border-blue-500 dark:border-blue-200"
                      )}
                    >
                      <div className="flex gap-2">
                        <div>
                          <img
                            src={method?.service_image}
                            className="h-6 w-6 rounded-full"
                            alt={method?.service_name}
                          />
                        </div>
                        <div className="grid gap-1">
                          <span className={textVariants()}>
                            {method?.service_name}
                          </span>
                          <span
                            className={textVariants({
                              size: "xs",
                              variant: "desc",
                            })}
                          >
                            {method?.fields?.account_number}
                          </span>
                        </div>
                      </div>
                      <div className="h-5 w-5 rounded-full bg-gray-100 dark:bg-grey-500 flex items-center justify-center">
                        {payment.includes(method?.id as string) && (
                          <Check className="h-4 w-4 text-blue-500 dark:text-blue-200" />
                        )}
                      </div>
                    </Card>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </Modal>
      <Modal
        title={t("app.components.modalTitles.addPaymentMethod")}
        open={modal === "open"}
        size={"md"}
        setOpen={(val) => setModal(val ? undefined : "open")}
      >
        <AddPayments country_id={Number(currency.slice(3, 6))} />
      </Modal>
    </>
  );
};

export default SellPayments;
